"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var media_query_1 = require("@chakra-ui/media-query");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return media_query_1.useBreakpointValue; } });
